var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMailBoxesLarge(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-152 -851) translate(101 90) translate(0 744) translate(51 16) translate(1 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8.724,
    height: 5.673,
    x: 5.067,
    y: 0.585,
    stroke: "currentColor",
    strokeWidth: 1.169,
    rx: 0.622
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EEF0F3",
    d: "M13.908 30.792c-.927 0-12.773-.109-12.97-.109-.47 0-.938-.394-.938-.824v-12.27c0-2.211 2.499-6.454 6.883-6.95 4.385-.496 8.155 4.018 8.155 7.332V29.86c-.441.622-.818.933-1.13.933z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 1.169,
    d: "M5.06 5.806v5.236c.534-.269 1.446-.403 2.734-.403h22.914c3.456 0 7.292 3.47 7.292 6.95v12.27c0 .524-.459.824-.793.824H.938c-.47 0-.938-.394-.938-.824v-12.27c0-2.211 2.499-6.454 6.883-6.95 4.385-.496 8.155 4.018 8.155 7.332 0 2.21-.04 6.348-.12 12.413"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.169,
    d: "M21.857 30.792L21.857 38.879"
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailBoxesLarge);
export default __webpack_public_path__ + "static/media/mail-boxes-large.610787dfb8393bacb711dc87f437ea48.svg";
export { ForwardRef as ReactComponent };